import { render } from "./SpinnerIcon.vue?vue&type=template&id=643b2e72"
const script = {}

import exportComponent from "/home/datakepler/public_html/deploy-cache/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__